import React from 'react'
import cn from 'classnames'
import { ImageAsset } from '../../../asset/image'
import { TypeAssetImage } from '../../../../lib/types'

import styles from './circular-images.module.scss'

type CircularImagesProps = {
  images: TypeAssetImage[]
  className?: string
  isLarge?: boolean
}

export const CircularImages: React.FC<CircularImagesProps> = ({ images, className, isLarge }) => {
  return (
    <div className={cn(className, styles.circularImages, { [styles.circularImagesLarge]: isLarge })}>
      {images.map((image) => (
        <div className={styles.circularImage} key={image.sys.id}>
          <ImageAsset structure={image} />
        </div>
      ))}
    </div>
  )
}
